import React from "react";
import { Hourglass } from "lucide-react";
import { motion } from "framer-motion";

const TestDeNiveau = () => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center px-4 text-center">
      {/* Icône avec animation de rotation */}
      <motion.div
        animate={{ rotate: [0, 0, 360, 360, 0] }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut",
          times: [0, 0.2, 0.5, 0.7, 1], // pauses quand l'icône est droite
        }}
      >
        <Hourglass size={64} className="text-orange-500 mb-4" />
      </motion.div>

      {/* Titre animé */}
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="text-2xl sm:text-3xl font-bold mb-2"
      >
        Cette page sera bientôt disponible !
      </motion.h2>

      {/* Paragraphe animé */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        className="text-gray-600 mb-6 max-w-md"
      >
        Les tests de niveau sont en cours de développement. En attendant,
        parcourez les autres pages.
      </motion.p>

      {/* Bouton animé
      <motion.button
        onClick={() => navigate("/quizz")}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, delay: 0.6 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-full font-semibold shadow-md transition"
      >
        Accéder aux quiz
      </motion.button> */}
    </div>
  );
};

export default TestDeNiveau;
